// extracted by mini-css-extract-plugin
export var logo = "_lx-2";
export var logoWrapper = "_lx-1";
export var strip = "_lx-0";